export const dictionary = {
  sendToFreight: 'باربری',
  sendToAdmin: 'مدیرسیستم',
  tendering: 'مناقصه',
  returned: 'برگشت بار',
  rejected: 'رد بار',
  getWaybill: 'صدور بارنامه',
  movingTowardsOrigin: 'بارگیری',
  transporting: 'درحال حمل',
  delivered: 'تحویل شده',
  canceled: 'کنسل بار',
  customer: 'صاحب بار',
  customers: 'صاحبین بار',
  driver: 'راننده',
  drivers: 'رانندگان',
  freight: 'باربری',
  freights: 'باربری ها',
  morningtillafternoon: 'از صبح تا بعدازظهر',
  morningtillnoon: 'از صبح تا ظهر',
  afternoon: 'از بعدازظهر',
  dusktilldown: 'از صبح تا غروب',
  '24h': 'بصورت ۲۴ ساعته',
  night: 'فقط شب',
  Ton: 'تن',
  Kg: 'کیلوگرم',
  admin: 'کارشناس حمل',
  operator: 'کارشناس حمل',
  customer: 'صاحب‌بار',
  driver: 'راننده',
  add_credit: 'شارژحساب',
  driver_pay_comission: 'کمسیون‌راننده',
  free_requested_deposit: 'واریز‌به‌ح‌مشتری',
  credit_deduction: 'کسرشارژ',
  freight_pay_commision: 'کمسیون‌باربری',
  pending: 'درحال‌بررسی',
  banned: 'معلق',
  active: 'فعال',
  add_credit: 'شارژ دستی',
  credit_deduction: 'برداشت دستی',
  pay_commission: 'پرداخت کمیسیون',
  // pos: 'POS کارت کشید',
  // cash: 'وجه نقد',
  Sunday: 'یکشنبه',
  Monday: 'دوشنبه',
  Tuesday: 'سه شنبه',
  Wednesday: 'چهارشنبه',
  Thursday: 'پنج شنبه',
  Friday: 'جمعه',
  Saturday: 'شنبه',
  _police: 'پلیس راهی',
  _software: 'نرم افزار',
  _custom: 'سفارشی',
  add_credit: ' افزایش اعتبار',
  credit_deduction: 'کسر اعتبار',
  pos: 'پرداخت پوز',
  cash: 'پرداخت نقدی',
  cardToCard: 'کارت‌ به کارت',
  toAccount: 'واریز به حساب',
  payWaybill: 'پرداخت بارنامه ',
  commission: 'هدیه فوتاب',
  payCommission: 'تسویه هدیه فوتاب',
  inProgress: 'منتشر شده',
  AGREED_WITH_CUSTOMER: 'توافق کردم',
  CUSTOMER_NOT_ANSWERED: 'جواب نداد',
  ORDER_WAS_CANCELED: 'خیر-بار رد شده',
  PRICE_IS_NOT_FAIR: 'کرایه عادلانه نبود',
  OTHER_REASONS: 'خیر-به دلایل دیگر',
  legal: 'تجاری',
  notLegal: 'غیرتجاری',
};
